import { api } from '@/lib/axios';

export interface AuditLogRow {
  id: string;
  user_id: string | null;
  user_label: string;
  entity_type: string;
  entity_id: string | null;
  action: string;
  changed_fields: Record<string, [unknown, unknown]> | null;
  module: string | null;
  created_at: string;
}

export interface AuditPage {
  items: AuditLogRow[];
  total: number;
  page: number;
  size: number;
  pages: number;
}

export interface AuditFiltres {
  entity_types: string[];
  actions: string[];
}

export interface AuditQuery {
  user_id?: string;
  entity_type?: string;
  action?: string;
  date_from?: string;
  date_to?: string;
  page?: number;
  size?: number;
}

/** Journal d'audit filtrable (lecture seule, Directeur/Admin). */
export async function listJournal(q: AuditQuery): Promise<AuditPage> {
  const params = Object.fromEntries(Object.entries(q).filter(([, v]) => v !== undefined && v !== ''));
  const { data } = await api.get<AuditPage>('/journal', { params });
  return data;
}

/** Options de filtrage (types d'entité audités + actions). */
export async function getAuditFiltres(): Promise<AuditFiltres> {
  const { data } = await api.get<AuditFiltres>('/journal/filtres');
  return data;
}
